import {ItemDefinition} from "./utils";
import logo from "../../static/images/unicorn.png";
import {
    getAllSharedTo,
    getNamesForTransfersLoop,
    getNumberOfDatasets,
    getNumberOfParties,
    getPartyName,
    listOfTransferNotProcessing10Parties, listOfTransferProcessing101112Parties
} from "./gdpr_flow_utils";
import {datasetTransferProcessing10} from "./gdpr_items";

const version = "0.0.1";
const name = "Unicorns!";
const id = 'unicorn0.0.1';

const first_item = new ItemDefinition({
    id: 'first_item',
    title: "Introduction",
    fields: [
        {
            label: "Are you a unicorn?",
            explanation: "Check if you have something pointy on your head if you are not sure",
            type: "yesno",
        },
        {
            label: "What's your name?",
            explanation: "",
            type: "text"
        },
        {
            label: "When were you born?",
            type: "date"
        }
    ],
    chooseNext: function (states) {
        const {values} = states[this.id];
        if (values[0] === 1) {
            return second_item_yes;
        } else {
            return second_item_no;
        }
    }
});
const second_item_yes = new ItemDefinition({
    id: 'second_item_yes',
    title: "Horn length",
    fields: [
        {
            label: "How long is your horn?",
            type: "dropdown",
            options: [
                {"key": "0", "text": "less than 5 cm", value: 0},
                {"key": "1", "text": "between 5 cm and 10 cm", value: 1},
                {"key": "2", "text": "more than 10 cm", value: 2},
            ],
        }
    ],
    chooseNext: function (states) {
        return third_item;
    }
});
const second_item_no = new ItemDefinition({
    id: 'second_item_no',
    title: "Becoming a unicorn",
    fields: [
        {
            label: "Would you like to become one?",
            type: "radio",
            options: [
                {"key": "y", "text": "yes", value: "true"},
                {"key": "n", "text": "no", value: "false"},
            ]
        }
    ],
    chooseNext: function (states) {
        return third_item;
    }
});

const third_item = new ItemDefinition({
    id: 'third_item',
    title: "Friends",
    fields: [
        {
            label: "How many unicorns do you know?",
            type: "dropdown",
            options: [
                {"key": "1", "text": "1", value: 1},
                {"key": "2", "text": "2", value: 2},
                {"key": "3", "text": "3", value: 3},
                {"key": "4", "text": "4", value: 4},
            ]
        }
    ],
    chooseNext: function (states) {
        return friend_item;
    }
});


const friend_item = new ItemDefinition({
    id: 'friend_item',
    loopName: "friends_loop",
    title: "Friend's name",
    fields: [
        {
            label: "What's her/his name?",
            type: "text",
        }
    ],
    chooseNext: function (states, globals, loopIndex, loops) {
        return friend_item2;
    }
});
const friend_item2 = new ItemDefinition({
    id: 'friend_item2',
    loopName: "friends_loop",
    title: "For real?",
    fields: [
        {
            label: "Are you sure it's not an imaginary friend?",
            type: "radio",
            options: [
                {"key": "y", "text": "yes", value: "true"},
                {"key": "n", "text": "no", value: "false"},
            ]
        }
    ],
    chooseNext: function (states, globals, loops) {
        const loopIndex = this.getLoopIndex(loops);
        const numberOfFriends = states[third_item.id].values[0];
        if (loopIndex === numberOfFriends) {
            return the_end;
        } else {
            return this.nextLoopIteration(loops);
        }
    }
});

const the_end = new ItemDefinition({
    id: 'theEnd',
    title: "THE END!!!!",
    fields: [],
    chooseNext: function (states) {
        return the_end;
    }
});

const items = [
    first_item,
    second_item_yes,
    second_item_no,
    third_item,
    friend_item,
    friend_item2,
    the_end
];
const loopsDefinitions =  {
    friends_loop: {
        name: "Unicorn friends",
        allowPreliminary: false,
        namePreliminarySection: 'Cohort\'s details',
        getIterationName: function (globals, loopState, loopIndex) {
            return loopIndex;
        },
        loopType: 'friends',
        hasMoreIterations: function (states, globals, loops) {
            const numberOfFriends = states[third_item.id].values[0];
            const loopIndex = loops["friends_loop"].index;
            return loopIndex !== numberOfFriends;
        }
    }
};
const flow = {id, items, name, version, logo, disclaimerText: "", loopsDefinitions};
export default flow;
